import * as React from "react";
import styled from "styled-components";
import styledMap from "styled-map";
import { palette } from "@conserveit/blocks";

export interface CosmeticProps {
  /** 12px */
  tiny?: boolean;
  /** 16px */
  small?: boolean;
  /** 40px */
  large?: boolean;
  /** Set on the icon itself, not the <svg> element */
  fillColor?: string;
}

const svgAttrs = {
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
};

export const SVG = styled.svg.attrs(svgAttrs)<CosmeticProps>`
  display: inline-block;
  fill: ${(props) => props.fillColor || palette.neutral7};
  width: ${styledMap`
    tiny: 12px;
    small: 16px;
    large: 40px;
    default: 24px;
  `};
  height: ${styledMap`
    tiny: 12px;
    small: 16px;
    large: 40px;
    default: 24px;
  `};
`;

const ArrowChevronRightIcon: React.FunctionComponent<CosmeticProps> = (
  props
) => (
  <SVG {...props}>
    <g>
      <path
        d="M6.00000164,11.9716182 C5.99923883,11.3099454 6.26395777,10.6799744 6.72650921,10.2426952 L17.1137046,0.432131679 C17.8295856,-0.212768904 18.8940889,-0.126172478 19.5112815,0.627172482 C20.1284741,1.38051744 20.0726006,2.5250542 19.3854379,3.2050083 L10.3022304,11.7836266 C10.2517896,11.8310937 10.2228649,11.8996072 10.2228649,11.9716182 C10.2228649,12.0436293 10.2517896,12.1121428 10.3022304,12.1596099 L19.3854379,20.7382282 C19.8635702,21.1689531 20.0868904,21.843918 19.9689828,22.5019392 C19.8510752,23.1599604 19.4104382,23.6978017 18.8175802,23.9073406 C18.2247222,24.1168795 17.5726561,23.9652417 17.1137046,23.5111048 L6.73023489,13.7035412 C6.26656377,13.2655132 6.00058813,12.6346883 6.00000164,11.9716182 Z"
        transform="translate(13.000000, 12.000000) scale(-1, 1) translate(-13.000000, -12.000000)"
      />
    </g>
  </SVG>
);

export const ArrowChevronRight = React.memo(styled(ArrowChevronRightIcon)``);
